export default (state) => {
    const { slides, currentIndex } = state;
    return slides[currentIndex];
  }




// WEBPACK FOOTER //
// ./src/components/slideshow/Slideshow/renderSlide.js